/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "jcaportalweb",
            "endpoint": "https://azx88q5rz7.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:501696f4-8a99-4444-a36b-67300ebd5f3b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_junIia7iA",
    "aws_user_pools_web_client_id": "23ebi0qeag2ed3d56ejkl6l3e6",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "jcaportalweb-master",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://di6x24wa2v8bu.cloudfront.net",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "AuditTrails-master",
            "region": "us-east-1"
        },
        {
            "tableName": "ConnectionEvents-master",
            "region": "us-east-1"
        },
        {
            "tableName": "PublicKeys-master",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
